export const validateHalfPostcode = (postcode: string) => {
  const halfPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]?|GIR)$/i
  return halfPostcodeRegex.test(postcode)
}
